const fullDate = (theDate) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'] 
    const theSplitDate = theDate.split('-');
    const spliceMonth = theSplitDate[1].substring(0, 1) === 0 ? theSplitDate[1].substring(1) - 1 : theSplitDate[1] - 1;
    const theFullDate = `${months[spliceMonth]} ${theSplitDate[2]}, ${theSplitDate[0]}`
    return(theFullDate)
}

export default fullDate;



// const fullDate = (theDate) => {
//     const months = Array.from({length: 12}, (item, i) => {
//         return new Date(0, i).toLocaleString('en-US', {month: 'short'})
//       });    
//     const theSplitDate = theDate.split('-');
//     const spliceMonth = theSplitDate[1].substring(0, 1) == 0 ? theSplitDate[1].substring(1) - 1 : theSplitDate[1] - 1;
//     const theFullDate = `${months[spliceMonth]} ${theSplitDate[2]}, ${theSplitDate[0]}`
//     return(theFullDate)
// }

// export default fullDate;